import { FeatherModule } from 'angular-feather';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export enum BadgeColors {
  grey = 'grey',
  green = 'green',
  red = 'red',
  black = 'black',
  yellow = 'yellow',
  blue = 'blue',
  purple = 'purple',
  orange = 'orange',
}

@Component({
  selector: 'lib-badge',
  imports: [FeatherModule, CommonModule],
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  readonly label = input<string>();
  readonly iconName = input<string>('');
  readonly colorScheme = input<BadgeColors>(BadgeColors.grey);
  readonly wrap = input<boolean>(true);
  readonly BadgeColors = BadgeColors; // keep exported for template comparisons if needed
}
